import { Alert, Button, Modal, ModalVariant, Stack, StackItem } from '@patternfly/react-core'
import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { Era5API, Era5DownloadJob } from '../../../client'
import { ActionState } from '../../../components/actionState'
import { queryClient } from '../../../services/api'
import { ERA5_DOWNLOAD_QUERYKEY } from '../constants'

const REQUEST_STATE_MESSAGES = {
  idle: <></>,
  pending: <Alert variant='info' title='Processando' isInline />,
  success: <Alert variant='success' title='Salvo com sucesso' isInline />,
  failure: <Alert variant='danger' title='Ocorreu um erro ao registrar o download' isInline />,
}

export function ModalConfirmacao({
  isOpen,
  onClose,
  onSuccess,
  data,
}: {
  isOpen: boolean
  onClose: () => void
  onSuccess: () => void
  data: Era5DownloadJob
}) {
  const [actionState, setActionState] = useState<ActionState>('idle')
  const { mutate } = useMutation({
    mutationFn: Era5API.createDownloadJob,
    onSuccess: async () => {
      setActionState('success')
      await queryClient.invalidateQueries([ERA5_DOWNLOAD_QUERYKEY])
      onSuccess()
    },
    onError: () => {
      setActionState('failure')
    },
    onSettled: () => {
      setActionState('idle')
    },
    onMutate: () => {
      setActionState('pending')
    },
  })

  useEffect(() => {
    if (isOpen && actionState === 'success') {
      const timerCloseModal = setTimeout(() => {
        onClose()
      }, 750)
      return () => clearTimeout(timerCloseModal)
    }
    if (isOpen && actionState === 'failure') {
      const timerCloseModal = setTimeout(() => {
        onClose()
      }, 5000)
      return () => clearTimeout(timerCloseModal)
    }
  }, [actionState])

  return (
    <Modal
      variant={ModalVariant.small}
      title={'Registrar Evento'}
      aria-label='modal-confirm-warning'
      id='modal-confirm-warning'
      isOpen={isOpen}
      onClose={onClose}
      actions={[
        <Button
          key='create'
          variant='primary'
          onClick={() => {
            if (actionState === 'success') {
              onSuccess()
            } else if (actionState === 'idle') {
              mutate({ requestBody: data })
            }
          }}
        >
          Sim
        </Button>,
        <Button key='cancelar' variant='danger' onClick={onClose}>
          Não
        </Button>,
      ]}
    >
      <Stack hasGutter>
        <StackItem>{REQUEST_STATE_MESSAGES[actionState]}</StackItem>
      </Stack>
      <span>
        Deseja realmente registrar o download de dados para a área <strong>{data?.area}</strong> de{' '}
        <strong>
          {new Date(data?.ts_in)?.toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
          })}
        </strong>{' '}
        a{' '}
        <strong>
          {new Date(data?.ts_fin)?.toLocaleDateString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
          })}
        </strong>
        ? Este evento não poderá ser alterado.
      </span>
    </Modal>
  )
}
